<template>
  <div class="topbar">
    <div class="dayin-div" @click="dialogVisiblePrinter = true;getUserDetail()"><i class="icon-iconfont iconfont icondayin" />{{$lang('面单格式设置')}}</div>

    <!-- 添加国际化 -->
    <el-select class="lm-i18n" v-model="i18nValue" @change="i18nChange">
      <el-option v-for="item in langList" :key="item.value" :value="item.value" :label="item.local"></el-option>
    </el-select>

    <!-- <el-button class="top-item">
      {{$lang('面单库存')}}：{{ userInfo.stockCount || 0}}
    </el-button> -->
    <el-dropdown>
      <div class="notice-icon" @click="noticeClick()">
        <i class="iconfont icontongyong-xiaoxigonggao"></i>
        <div class="notice-num">{{ noticeUnread > 99 ? '99+' : noticeUnread }}</div>
      </div>
      <el-dropdown-menu v-show="false"></el-dropdown-menu>
    </el-dropdown>
    <el-dropdown>
      <span class="el-dropdown-link">
        <span class="user-avatar top-round-btn">
          <!-- <i class="iconfont icontouxiang"></i> -->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icontouxiang"></use>
          </svg>
        </span>
        <span class="name">{{ userInfo.account }}</span>
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="clickDownitem('1')">{{ $lang('我的资料') }}</el-dropdown-item>
        <el-dropdown-item @click.native="clickDownitem('2')">{{ $lang('退出登录') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      :title="dialogTitle"
      custom-class="topBarDiadlog"
      :visible.sync="dialogFormVisible"
      width="1100px"
      @close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      top="100"
      @open="topBarOpen"
      :show-close="true"
    >
      <el-row>
        <el-col :span="4">
          <!-- <i class="icontouxiang iconfont information"></i> -->
          <svg class="icon information" aria-hidden="true">
            <use xlink:href="#icontouxiang"></use>
          </svg>
        </el-col>
        <el-col :span="20">
          <el-row>
            <el-col :span="8">
              <span>{{ $lang('用户名称') }}：</span>
              <span class="form-item">{{ form.customerName }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('我的编码') }}：</span>
              <span class="form-item">{{ form.customerCode }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('绑定手机号') }}：</span>
              <span class="form-item">{{ form.contactMobile }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('账号类型') }}：</span>
              <span class="form-item">
                {{ form.type === 1 ? $lang('主账号') : $lang('子账号') }}
              </span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('账号状态') }}：</span>
              <span class="form-item">{{ form.status === 1 ? $lang('启用') : $lang('禁用') }}</span>
            </el-col>
            <!-- <el-col :span="8">
                        <span>{{$lang('当前面单库存')}}：</span>
                        <span class="form-item">{{ form.stockCount }}</span>
                    </el-col> -->
            <el-col :span="8">
              <span>{{ $lang('签约网点') }}：</span>
              <span class="form-item">{{ form.networkName }}</span>
            </el-col>
            <el-col :span="16" v-if="userInfo.parentId === 0">
              <el-form ref="form" :rules="formRules" :model="form">
                <el-form-item   prop="billEmail"  class="emitBox">
                  <span>{{ $lang('账单接收邮箱') }}：</span>
                  <el-input :disabled="emitState" style="width: 280px!important;" :placeholder="$lang('请填写账单接收邮箱')" v-model="form.billEmail"></el-input>
                  <el-button type="primary" class="h32 m24" :loading="emailLoag" plain @click="switchEmitState">{{ emitState?$lang('编辑邮箱'):$lang('保存') }}</el-button>
                 </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="modify-password-box" v-if="isModifyPassword">
        <el-form class="el-form-edit" ref="isAdd" :rules="rules" :inline="true" :model="resetPasswork" label-position="left" label-suffix=" :">
          <div class="modifyPasswork">
            <el-form-item :label="$lang('旧密码')" prop="oldPassword" class="modifyPassworkItem">
              <el-input v-model="resetPasswork.oldPassword" :placeholder="$lang('请输入旧密码')" show-password maxlength="18"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('新密码')" prop="newPassworkF" class="modifyPassworkItem">
              <el-input v-model="resetPasswork.newPassworkF" :placeholder="$lang('请输入新密码')" show-password maxlength="18"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('确认新密码')" prop="newPassworkS" class="modifyPassworkItem">
              <el-input v-model="resetPasswork.newPassworkS" :placeholder="$lang('请输入新密码')" show-password maxlength="18"></el-input>
            </el-form-item>
          </div>
          <div style="text-align:center">
            <el-button type="primary" @click="goModifyPassword" size="big" plain="">{{ $lang('取消') }}</el-button>
            <el-button type="primary" @click="submit" size="big" style="margin-left:20px">{{ $lang('确认修改') }}</el-button>
          </div>
        </el-form>
      </div>
      <div class="myAccount" v-if="!isModifyPassword">
        <div>
          <label>{{ $lang('登录账号') }}：</label>
          <el-input disabled v-model="form.account"></el-input>
          <el-button type="primary" class="h32 m24" plain @click="goModifyPassword">{{ $lang('修改密码') }}</el-button>
        </div>
      </div>
      <!-- <div class="myAccountPasswork">
        <div>
          <label>{{ $lang('面单格式') }}：</label>
          <el-select v-model="form.surfaceFormat" :placeholder="$lang('请选择')" :disabled="isPrintType">
            <el-option v-for="item in printTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <label class="m24">{{ $lang('默认打印机') }}：</label>
          <el-select v-model="form.targetPrinter" :placeholder="$lang('请选择')" :disabled="isPrintType">
            <el-option v-for="item in printNameList" :key="item" :label="$lang(item)" :value="item"> </el-option>
          </el-select>
          <el-button type="primary" plain class="h32 m24" @click="isPrintType = !isPrintType" v-show="isPrintType">{{ $lang('修改面单格式') }}</el-button>
          <el-button type="primary" plain class="h32 m24" v-show="!isPrintType" size="big" @click="savePrint">{{ $lang('保存') }}</el-button>
        </div>
      </div> -->
    </el-dialog>

    <!-- 公告弹框 -->
    <noticeDialog
      :visible.sync="dialogVisible"
      :noticeContent="noticeContent"
      :showClose="false"
      @updateVisible="updateVisible"
      @Read="readNotice"
      @handleClose="handleClose"
      :popupWidth="'920px'"
      ref="noticeDialog"
    >
    </noticeDialog>

    <el-dialog
      :title="$lang('面单格式设置')"
      :visible.sync="dialogVisiblePrinter"
      width="450px"
      custom-class="topBarDiadlog"
      >
      <div class="myAccountPasswork">
        <div>
          <label>{{$lang('面单格式')}}：</label>
          <el-select v-model="form.surfaceFormat" :placeholder="$lang('请选择')">
            <el-option v-for="item in printTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
        <div>
          <label>{{$lang('是否打印COD金额')}}：</label>
            <el-select v-model="form.needCod" :placeholder="$lang('请选择')">
                <el-option
                  v-for="item in isPrivacyList"
                  :key="item.value"
                  :label="$lang(item.label)"
                  :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div>
          <label>{{$lang('备注字号')}}：</label>
            <el-select v-model="form.worldRemark" :placeholder="$lang('请选择')">
                <el-option
                  v-for="item in remarkSizeList"
                  :key="item.value"
                  :label="$lang(item.label)"
                  :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div>
          <label>{{$lang('是否打印拣货信息')}}：</label>
          <el-select v-model="form.needPickup" :placeholder="$lang('请选择')">
            <el-option
              v-for="item in goodsDetailType"
              :key="item.value"
              :label="$lang(item.label)"
              :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" :content="$lang('启用后，系统将优先打印拣货信息，仅当有额外空间时才会打印备注信息，请合理规划。')" placement="top">
            <i class="el-icon-question" style="margin-left: 6px;font-size: 16px;"></i>
          </el-tooltip>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisiblePrinter = false">{{$lang('取消')}}</el-button>
        <el-button type="primary" @click="savePrint">{{$lang('确认修改')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'
import { RULES } from '@utils/rules'
import { UserDetail, noticeUnRead, noticeReaded, changeEmail } from '@api/module/customer'
import noticeDialog from '@components/dialog/noticeDialog'

export default {
  name: 'Topbar',
  components: {
    noticeDialog
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.resetPasswork.newPassworkF) {
        callback(new Error(this.$lang('两次密码输入不一致!')))
      } else {
        callback()
      }
    }
    return {
      name: 'admin',
      emailLoag: false,
      // 公告相关
      noticeUnread: 0, // 公告数量
      dialogVisible: false, // 公告弹窗
      noticeContent: {}, // 公告详情
      showform: true,
      dialogTitle: this.$lang('我的资料'),
      show: false,
      isPrintType: true,
      dialogFormVisible: false,
      isModifyPassword: false, // 是否修改密码
      isPrivacyTap: true, // 隐私面单
      emitState: true,
      remarkSizeList: [
        {
          value: 1,
          label: '小'
        },
        {
          value: 2,
          label: '大'
        },
      ],
      printTypeList: [
        {
          value: 1,
          label: this.$lang('不默认面单格式')
        },
        {
          value: 2,
          label: this.$lang('一联面单')
        },
        {
          value: 3,
          label: this.$lang('二联面单')
        },
        {
          value: 4,
          label: this.$lang('A4打印模板')
        }
      ],
      isPrivacyList: [
        {
          value: 1,
          label: this.$lang('是')
        },
        { value: 0, label: this.$lang('否') }
      ],
      isPrivacy: 0, // 是否隐私面单 0:否 1:是
      printNameList: [],
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        account: '',
        contactMobile: '',
        surfaceFormat: 1,
        targetPrinter: '',
        needCod: 0,
        billEmail: '',
        needPickup: 0, // 是否打印拣货信息
        worldRemark: 1 // 备注字号
      },
      resetPasswork: {
        oldPassword: '',
        newPassworkF: '',
        newPassworkS: ''
      },
      formLabelWidth: '120px',
      rules: {
        oldPassword: [RULES.required, RULES.checkPassword],
        newPassworkF: [RULES.required, RULES.checkPassword],
        newPassworkS: [RULES.required, RULES.checkPassword, { validator: validatePass, trigger: 'blur' }]
      },
      i18nValue: '',
      dialogVisiblePrinter: false,
      goodsDetailType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ]
    }
  },
  computed: {
    formRules() {
      return {
        billEmail: [RULES.checkEmail],
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    isUpdateStock() {
      return this.$store.state.base.isUpdateStock || false
    },
    isNoticeNum() {
      return this.$store.state.base.noticeUnread
    },
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    },
    // 国际化列表
    langList() {
      return this.$store.state.base.langList
    }
  },
  watch: {
    async isUpdateStock(value) {
      if (value) {
        try {
          this.getUserDetail()
          this.UPDATE_PRINT_STOCK(false)
        } catch (error) {
          this.UPDATE_PRINT_STOCK(false)
        }
      }
    },
    lang: {
      handler(val, oldVal) {
        this.i18nValue = val
      },
      immediate: true
    },
    isNoticeNum(value) {
      if (value !== this.noticeUnread) {
        this.noticeUnread = value
      }
    }
  },
  mounted() {
    this.getNoticeUnRead()
  },
  methods: {
    ...mapActions(['LOGIN_OUT', 'SET_USER', 'UPDATE_PRINT_STOCK', 'SET_LANG', 'NOTICE_UNREAD']),
    // 语言切换
    i18nChange(lang) {
      this.SET_LANG(lang)
    },
    checkIsInstall() {
      try {
        this.printNameList = []
        this.LODOP = this.$getLodop()
        this.hasLodop = !!this.LODOP.VERSION
        const printCount = this.LODOP.GET_PRINTER_COUNT()
        // 获取所有打印机的名称
        for (let i = 0; i < printCount; i++) {
          this.printNameList.push(this.LODOP.GET_PRINTER_NAME(i))
        }
      } catch (err) {
        console.log('print:' + err)
      }
    },
    topBarOpen() {
      this.emitState = true
      this.emailLoag = false
    },
    switchEmitState() {
      if (this.emitState) {
        this.emitState = false
        return
      }
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.emailLoag = true
          const params = {
            billEmail: this.form.billEmail
          }
          const res = await changeEmail(params)
          if (res.code === RESPONSE_SUCCESS) {
            this.emailLoag = false
            this.emitState = true
            this.SET_USER({ ...this.userInfo, ...params })
            this.$message.success(this.$lang('保存成功'))
          } else {
            this.emailLoag = false
            this.$message.error(res.msg)
          }
        }
      })
    },
    slideDowm() {
      this.show = !this.show
    },
    clickDownitem(index) {
      this.show = true
      switch (index) {
        case '1':
          this.Go()
          break
        case '2':
          this.Logout()
          break
      }
    },
    async getUserDetail () {
      const { code, msg, data } = await UserDetail({ id: this.userInfo.id })
      if (code !== 1) {
        this.$message.error(this.$lang(msg))
        return
      }
      this.form.stockCount = data.stockCount || 0
      this.form.networkName = data.networkName || '--'
      this.form.surfaceFormat = data.surfaceFormat || 1
      this.form.needCod = data.needCod || 0
      this.form.customerName = data.customerName || '--'
      this.form.contactMobile = data.contactMobile || '--'
      this.form.status = data.status
      this.isPrivacy = data.isPrivacy || 0
      this.form.worldRemark = data.worldRemark || 1
      this.form.needPickup = data.needPickup || 0
      // this.form.billEmail = data.billEmail || ''
      this.SET_USER({ ...this.userInfo, ...data }) // 更新vuex的用户数据
    },
    async Go() {
      this.checkIsInstall()
      this.dialogFormVisible = true
      this.form.account = this.userInfo.account
      this.form.customerCode = this.userInfo.customerCode
      this.form.type = this.userInfo.type
      this.form.targetPrinter = this.userInfo.targetPrinter
      this.form.billEmail = this.userInfo.billEmail || ''
      // this.form.status = this.userInfo.status
      // this.form.customerName = this.userInfo.customerName || '--'
      // this.form.contactMobile = this.userInfo.contactMobile || '--'
      this.getUserDetail()
    },
    handleClose() {
      this.showform = true
      this.resetPasswork.oldPassword = ''
      this.resetPasswork.newPassworkF = ''
      this.resetPasswork.newPassworkS = ''
      this.isPrintType = true
      this.$nextTick(function() {
        if (this.$refs['isAdd']) {
          this.$refs['isAdd'].resetFields()
        }
      })
    },
    Logout() {
      this.LOGIN_OUT().then(() => {
        // this.$common.setCookie('account', '')
        // this.$common.setCookie('pwd', '')
        this.$router.push({ name: 'login' })
      }) // 触发vuex的退出,
    },
    // goModifyPassword() {
    //   this.showform = !this.showform
    //   this.show = false
    //   this.dialogTitle = '修改密码'
    // },
    /*
     * 修改密码
     */
    goModifyPassword() {
      this.isModifyPassword = !this.isModifyPassword
    },
    goBack() {
      this.showform = !this.showform
      this.show = false
      this.dialogTitle = this.$lang('我的资料')
      this.$nextTick(function() {
        if (this.$refs['isAdd']) {
          this.$refs['isAdd'].resetFields()
        }
      })
    },
    changePasswordCb() {
      this.$confirm(this.$lang('密码修改成功'), this.$lang('提示'), {
        confirmButtonText: this.$lang('确定'),
        closeOnClickModal: false,
        showCancelButton: false,
        type: 'success',
        confirmButtonClass: 'comfirm-btn',
        iconClass: 'el-icon-warning-outline'
      })
        .then(() => {
          this.LOGIN_OUT().then(() => {
            this.$router.push({ name: 'login' })
          })
        })
        .catch(_ => {
          this.LOGIN_OUT().then(() => {
            this.$router.push({ name: 'login' })
          })
        })
    },
    async savePrint() {
      const params = {
        surfaceFormat: this.form.surfaceFormat,
        needCod: this.form.needCod,
        targetPrinter: this.form.targetPrinter,
        worldRemark: this.form.worldRemark,
        needPickup: this.form.needPickup
      }
      try {
        const res = await Api.savePrintSetup(params)
        if (res.code === RESPONSE_SUCCESS) {
          const user = { ...this.userInfo, ...params }
          this.SET_USER(user) // 更新vuex的用户数据
          this.isPrintType = true
          this.dialogVisiblePrinter = false
          this.$message.success(this.$lang('保存成功'))
        } else {
          this.$message.error(res.msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async submit() {
      this.$refs['isAdd'].validate(async valid => {
        if (valid) {
          const params = {
            oldPwd: this.$Base64.encode(this.resetPasswork.oldPassword + 'jadada236t2'),
            pwd: this.$Base64.encode(this.resetPasswork.newPassworkF + 'jadada236t2')
          }
          const res = await Api.CHANGE_PASSWORD(params)
          if (res.code === RESPONSE_SUCCESS) {
            this.dialogFormVisible = false
            this.changePasswordCb()
          } else {
            this.$message.error(res.msg)
          }
        } else {
          return false
        }
      })
    },
    /**
     * @description 保存隐私面单
     */
    async savePrivacy() {
      const params = {
        isPrivacy: this.isPrivacy
      }
      const res = await Api.savePrivacy(params)
      if (res.code === RESPONSE_SUCCESS) {
        this.isPrivacyTap = true
        this.$message.success(this.$lang('保存成功'))
      } else {
        this.$message.error(res.msg)
      }
    },

    // 打开公告弹窗
    openNotice() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.noticeDialog && this.$refs.noticeDialog.startCountdown()
      })
    },
    //  已读回调
    async goReaded(params) {
      const { code } = await noticeReaded(params)
      if (code === 1) {
        this.dialogVisible = false
        const noticeUnread = parseInt(this.$store.state.base.noticeUnread) - 1
        this.NOTICE_UNREAD(noticeUnread)
        this.noticeUnread = noticeUnread
      }
    },
    // 修改是否让页面显示与隐藏的事件
    updateVisible(val) {
      this.dialogVisible = val
    },
    async getNoticeUnRead() {
      const params = {
        isRead: 1,
        pushPlatform: 2
      }
      const { code, data } = await noticeUnRead(params)
      if (code === 1) {
        this.noticeUnread = data.unReadCount > 99 ? '99+' : data.unReadCount
        this.NOTICE_UNREAD(data.unReadCount)
        if (data.openForceNotice) {
          this.noticeContent = data.openForceNotice
          this.openNotice()
        }
      }
    },
    // 已阅读 的事件
    readNotice() {
      //  这里可修改数据
      console.log(1111)
      const noticeIds = []
      noticeIds.push(this.noticeContent.id)
      const params = {
        noticeIds: noticeIds
      }
      this.goReaded(params)
    },
    noticeClick() {
      this.$router.push({ name: 'notice' })
    }
  }
}
</script>
<style lang="scss" rel="text/css">
$iconSize: 20px;
$themeBorder: 3px;
$top-btn-width: 24px;
.m24 {
  margin-left: 24px;
}

.notice-icon {
  display: inline-block;
  margin-left: 24px;
  margin-right: 36px;
  position: relative;
  cursor: pointer;
  .notice-num {
    display: inline-block;
    width: 30px;
    height: 16px;
    font-size: 12px;
    color: #e60012;
    opacity: 1;
    background: #fde6e7;
    border: 2px solid #ffffff;
    border-radius: 10px;
    position: absolute;
    top: 7px;
    left: 8px;
    line-height: 15px;
    text-align: center;
  }
}
.topbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #000;
  height: 100%;
  position: relative;
  line-height: 48px;
  transition: all 0.2s linear;
  .dayin-div {
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    cursor: pointer;
    i {
      font-size: 18px;
    }
  }
  .lm-i18n {
    // position: absolute;
    // right: 10px;
    // top: 10px;
    width: 90px;
    margin-right: 10px;
    .el-input {
      width: 100% !important;
    }
    .el-input__inner {
      padding: 0 15px !important;
      border-radius: 10px !important;
      border: 1px solid #999 !important;
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input__inner::placeholder,
    .el-input__inner::-webkit-input-placeholder {
      color: #fff;
    }
  }
  .top-item {
    color: #666666;
    margin-right: 16px;
    line-height: 5px;
    font-weight: 400;
    // width: 120px;
    height: 24px;
    background: #edeef3;
    border-radius: 12px;
    cursor: default;
    &:hover {
      border-color: #ddd;
    }
  }
  .el-dropdown-link {
    display: flex;
    cursor: pointer;
  }
  .top-round-btn {
    margin-right: 8px;
    .icon {
      position: relative;
      top: 5px;
      font-size: 24px;
    }
  }
  .name {
    max-width: 98px;
    line-height: 48px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    margin-right: 16px;
  }
  i {
    line-height: 48px;
  }
  .information {
    font-size: 80px;
    top: 10px;
    position: relative;
  }
  .down-pover {
    position: absolute;
    right: 0;
    top: 48px;
    width: calc(100% - 190px);
    z-index: 100;
    background: inherit;
    margin: 0;
    list-style: none;
    padding-left: 20px;
    padding-bottom: 10px;
    min-width: 100px;
    li {
      line-height: 30px;
      font-size: 14px;
      cursor: pointer;
      opacity: 0.6;
      &:hover {
        opacity: 1;
        color: #e0bd7b;
      }
    }
  }
  .tooltip-click {
    background: red;
    cursor: pointer;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    -webkit-text-fill-color: #fff;
  }
  .el-dialog {
    .el-dialog__body {
      padding: 30px 48px;
    }
    .el-dialog__header {
      border-bottom: 1px solid #eeeeee;
      .el-dialog__headerbtn {
        top: 0px;
      }
    }
    .el-dialog__footer {
      border-top: 1px solid #eeeeee;
    }
    .myDetail {
      display: inline-flex;
      padding-bottom: 24px;
      .myDetailInfo {
        margin-top: -25px;
        .item-row {
          display: inline-flex;
        }
      }
      .myAvatar {
        width: 90px;
        height: 90px;
        line-height: 145px;
        background: rgb(102, 102, 102);
        color: rgb(216, 216, 216);
        border-radius: 90px;
        margin-right: 24px;
        i {
          font-size: 90px;
        }
      }
      .myDetailItem {
        width: 170px;
        font-size: 14px;
        line-height: 18px;
        .myDetailItemText {
          color: #999999;
          padding-bottom: 8px;
          padding-top: 25px;
        }
      }
    }
    .modify-password-box {
      background: #eee;
      border-radius: 8px;
      padding: 24px;
    }
    .myAccount {
      margin-top: 36px;
    }
    // .myAccountPasswork{
    // margin-top: 12px;
    // }
  }
  .emitBox{
    i{
      line-height: normal;
    }

  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    padding: 0 40px 0 20px !important;
    list-style: none;
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    outline: none;
  }
}
.el-dropdown-link:hover {
  .name {
    color: $--color-primary;
  }
}
.topbar .topBarDiadlog {
  .el-dialog__header {
    span {
      font-size: 24px !important;
      font-weight: 700 !important;
    }
  }
  .el-col-8,.el-col-16 {
    color: #999999;
    display: flex;
  }
  .form-item {
    color: #333;
    font-weight: 700;
    text-overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    // width: 90px;
    white-space: nowrap;
  }
}
</style>
